import orderProductTags from './orderProductTags';

export function storeCategoryOrder(grouped, vendor) {
  const custom = vendor?.storefrontCategories || [];
  if (!custom.length) return orderProductTags(Object.keys(grouped), vendor?.productTagOrder);
  return [...custom.map(category => category.name).filter(name => grouped[name]), ...(grouped['Other Products'] ? ['Other Products'] : [])];
}

export function groupStoreProducts(products, vendor) {
  const custom = vendor?.storefrontCategories || [];
  const grouped = Object.create(null);
  if (custom.length) {
    const assigned = new Set();
    const byId = new Map(products.map(product => [String(product._id), product]));
    for (const category of custom) {
      const matches = [...new Set((category.productIds || []).map(String))].map(id => byId.get(id)).filter(Boolean);
      matches.forEach(product => assigned.add(String(product._id)));
      if (matches.length) grouped[category.name] = matches;
    }
    const other = products.filter(product => !assigned.has(String(product._id)));
    if (other.length) grouped['Other Products'] = other;
    return grouped;
  }
  const names = [...new Set(products.flatMap(product => product.productTags || []).filter(Boolean))];
  for (const name of orderProductTags(names, vendor?.productTagOrder)) {
    grouped[name] = products.filter(product => product.productTags?.includes(name));
  }
  const other = products.filter(product => !product.productTags?.length);
  if (other.length) grouped['Other Products'] = other;
  return grouped;
}
